import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData } from 'react-router-dom'

import MessagesView from '@components/myScores/MessagesView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { MessagesLoaderResponse } from '@pages/home/loaders/messages.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const MessagesPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as MessagesLoaderResponse

  usePageTitle(t('titles.messages'))

  return (
    <Suspense
      fallback={
        <>
          <div className="h-16" />
          <LoadingSpinner />
        </>
      }>
      <Await resolve={data.messages}>
        {(messagesResp) => <MessagesView initialData={messagesResp} />}
      </Await>
    </Suspense>
  )
}

export default MessagesPage
